import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=6a09a5b2&scoped=true"
import script from "./OrdersSummary.vue?vue&type=script&lang=js"
export * from "./OrdersSummary.vue?vue&type=script&lang=js"
import style0 from "./OrdersSummary.vue?vue&type=style&index=0&id=6a09a5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09a5b2",
  null
  
)

export default component.exports